module.exports = __webpack_public_path__ + "static/media/ebi_gunkan.88a67a2e.jpeg";